module.exports = __webpack_public_path__ + "img/goal_m01-2.eb126e31.jpg";